var exports = {
  "B": "AuthCardContainer.module__inertOverlay___anJIeG",
};

module.exports = exports;
